"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function useApiLoad(fetchMethod, deps) {
    const [data, setData] = react_1.default.useState(undefined);
    const [trigger, setTrigger] = react_1.default.useState(false);
    const [loading, setLoading] = react_1.default.useState(false);
    const doRefresh = react_1.default.useMemo(() => () => setTrigger(!trigger), [trigger]);
    react_1.default.useEffect(() => {
        const fetch = () => __awaiter(this, void 0, void 0, function* () {
            setLoading(true);
            try {
                const r = yield fetchMethod();
                setData(r);
            }
            finally {
                setLoading(false);
            }
        });
        fetch();
    }, [trigger, ...deps]);
    return [data, loading, doRefresh, setData];
}
exports.default = useApiLoad;
